export default {
      id: "planner-dropper-usage",
      viewBox: "0 0 29 40",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#planner-dropper",
      toString: function () {
        return this.url;
      }
    }